import React, { Component } from 'react';
import { Typography } from 'antd';
import productImage from './../assets/default_product.png';

class CpProductInfo extends Component {
  render() {
    const { product: { product_img, sale_image, sku_img, sale_name, sale_norms, sku_unit_desc, sku_name, spec, false_reason, mapping = {}, sku_no, out_sku_no }, toProductDetail = () => { }, showUnit, showSku } = this.props;
    const computedOutSkuNo = mapping?.out_sku_no;
    const productImg = product_img || sale_image || sku_img, saleNorms = sale_norms || sku_unit_desc || spec, saleName = sale_name || sku_name;
    return (
      <div className="product-info-wrap">
        <img className="image-item" src={productImg || productImage} alt=""></img>
        <div className="title-wrap">
          <div className="title">
            <Typography.Link style={{ color: '#000' }} onClick={() => { toProductDetail(); }}>{saleName}</Typography.Link>
          </div>
          {false_reason ? <div><Typography.Link>{false_reason}</Typography.Link></div> : null}
          {showSku ? <><div style={{ fontSize: 12 }}>商品编码：{sku_no}</div><div style={{ fontSize: 12 }}>ERP商品编码：{out_sku_no}</div></> : null}
          {showUnit ? <div style={{ fontSize: 12 }}><span>单位：</span>{saleNorms}</div> : <div style={{ fontSize: 12 }}><span>规格：</span>{saleNorms}</div>}
          <div style={{ fontSize: 12 }}>{!['', null, undefined, '-'].includes(computedOutSkuNo) ? `ERP编码：${computedOutSkuNo}` : null}</div>
        </div>
      </div>
    );
  }
}

export default CpProductInfo;